import { useRequest } from 'ahooks'

import { queryOrderCoalQuantityDetailApi } from '@eastcoal/api/trade/orderMember/queryOrderCoalQuantityDetail'

export const useKindQuantityRequest = ({ type }: { type: number }) => {
  const { data } = useRequest(
    () => queryOrderCoalQuantityDetailApi({ type }, { silence: true }),
    {
      manual: false,
      refreshDeps: [type]
    }
  )

  return [
    {
      label: '总成交量',
      value: data?.quantity ?? 0,
      unit: '吨'
    },
    {
      label: '竞价成交量',
      value: data?.auctionQuantity ?? 0,
      unit: '吨'
    },
    {
      label: '挂牌成交量',
      value: data?.listingQuantity ?? 0,
      unit: '吨'
    }
  ]
}
